export const TRANSLATIONS_JP_HOME_PULSE_AND_CALENDAR = {
  "home.pulse.eyebrow": "リアルタイム分類エンジン",
  "home.pulse.subtitle": "いま Innovadoc IA がドキュメントをどうラベルしているかを監視しています。",
  "home.pulse.originNote": "ここで得た理解が、このホームにある期日・優先度・アクションの基盤です。",
  "home.pulse.state.ok": "問題なし",
  "home.pulse.state.processing": "注意が必要",
  "home.pulse.state.attention": "緊急",
  "home.pulse.summary.documents": "理解済みドキュメント",
  "home.pulse.summary.artifacts": "把握したアーティファクトタイプ",
  "home.pulse.summary.categories": "認識済みカテゴリ",
  "home.pulse.summary.overdue": "期限切れ",
  "home.pulse.summary.upcoming": "期限間近",
  "home.pulse.modal.eyebrow": "重要な日付",
  "home.pulse.modal.overdueTitle": "期限切れのドキュメント",
  "home.pulse.modal.upcomingTitle": "期限間近のドキュメント",
  "home.pulse.modal.countLabel": "表示",
  "home.pulse.modal.ofLabel": "件中",
  "home.pulse.modal.dueLabelOverdue": "期限切れ日",
  "home.pulse.modal.dueLabelUpcoming": "期限",
  "home.pulse.modal.roleLabel": "役割",
  "home.pulse.modal.stateLabel": "状態",
  "home.pulse.modal.actionLabel": "アクション",
  "home.pulse.modal.close": "閉じる",
  "home.pulse.modal.viewDocument": "ドキュメントを見る",
  "home.pulse.modal.openQueue": "優先リストを開く",
  "home.pulse.modal.overdueEmpty": "期限切れのドキュメントはありません。",
  "home.pulse.modal.upcomingEmpty": "期限間近のドキュメントはありません。",
  "home.pulse.modal.limitedHint": "一部のみ表示。すべて見るには優先リストを開いてください。",
  "home.pulse.artifactTypes.title": "検出されたアーティファクトタイプ",
  "home.pulse.artifactTypes.showMore": "さらに表示",
  "home.pulse.artifactTypes.showLess": "折りたたむ",
  "home.pulse.recentClassifications.title": "最新の分類",
  "home.pulse.recentClassifications.countLabel": "件",
  "home.pulse.recentClassifications.empty": "直近1時間の分類はありません。",
  "home.pulse.empty": "パルスデータはまだありません。",
  "home.datesSummary.eyebrow": "重要な日付",
  "home.datesSummary.title": "文書の重要な日付",
  "home.datesSummary.totalLabel": "期限が近い文書",
  "home.datesSummary.description": "見逃したくない更新や締め切りが近づいています。",
  "home.datesSummary.connection": "締め切りが近い順に並べています。",
  "home.datesSummary.roleLabel": "担当",
  "home.datesSummary.role.renewal": "更新",
  "home.datesSummary.role.audit": "監査",
  "home.datesSummary.role.expiration": "期限切れ",
  "home.datesSummary.role.compliance": "コンプライアンス",
  "home.datesSummary.tooltip": "文書から自動的に検出しています。",
  "home.datesSummary.clearFilter": "ロールのフィルターを解除",
  "home.datesSummary.panelEyebrow": "重要な日付",
  "home.datesSummary.panelTitle": "文書の重要な日付",
  "home.datesSummary.panelSubtitle": "確認しておきたい文書と近づく日付の一覧です。",
  "home.datesSummary.closePanel": "日付パネルを閉じる",
  "home.datesSummary.panelQueueCta": "これらの文書を見る",
  "home.datesSummary.panelFilterActive": "フィルター中: このロールのみを表示。",
  "home.datesSummary.panelEmpty": "表示できる検出済み日付はありません。",
  "home.datesSummary.empty": "検出された日付はまだありません。",
  "home.datesSummary.filterSaved": "設定を保存しました。",
  "home.datesSummary.state.active": "進行中",
  "home.datesSummary.state.upcoming": "近日",
  "home.datesSummary.state.resolved": "解決済み",
  "home.datesSummary.previewTitle": "今後の期限",
  "home.datesSummary.previewSubtitle": "締め切り順",
  "home.datesSummary.previewAction": "一覧を見る",
  "home.datesSummary.previewChangeRole": "担当を変更",
  "home.datesSummary.previewOpenCalendar": "カレンダーを開く",
  "home.stats.title": "現在のドキュメント理解サマリー",
  "home.stats.description": "分類の健全性を確認するための指標です。",
  "home.stats.note": "ここでの指標が上部の推奨と優先リストを支えています。",
  "home.stats.label.pending_documents": "保留中ドキュメント",
  "home.stats.label.evaluated_documents": "評価済みドキュメント",
  "home.stats.label.oldest_pending_age_seconds": "最古の保留期間 (秒)",
  "home.stats.label.last_evaluation_age_seconds": "最後の評価からの経過 (秒)",
  "home.stats.label.evaluation_duration_p95_ms": "評価時間 p95 (ms)",
  "home.stats.label.evaluation_duration_p99_ms": "評価時間 p99 (ms)",
  "home.stats.label.ranker_duration_p95_ms": "ランカー時間 p95 (ms)",
  "home.stats.label.ranker_duration_p99_ms": "ランカー時間 p99 (ms)",
  "home.stats.label.error_rate": "エラー率",
  "home.stats.label.throughput_eval_per_hour": "評価/時間",
  "home.stats.label.throughput_rank_per_hour": "ランク/時間",
  "home.stats.empty": "利用可能なメトリクスはまだありません。",
  "home.decisionPulse.eyebrow": "運用パルス",
  "home.decisionPulse.headline.alert": "すぐに注意が必要な決定があります",
  "home.decisionPulse.headline.watch": "負荷は安定していますが、近いうちに動く必要があります",
  "home.decisionPulse.headline.calm": "現時点では全体的に落ち着いています",
  "home.decisionPulse.copy.actNow": "は即時対応が必要です",
  "home.decisionPulse.copy.overdue": "は期限超過です",
  "home.decisionPulse.copy.actSoon": "は近日中に処理すべきです",
  "home.decisionPulse.copy.monitoring": "件の決定が監視中です",
  "home.decisionPulse.copy.empty": "現在アクティブな決定はありません。",
  "home.decisionPulse.connection.label": "SSE",
  "home.decisionPulse.connection.connecting": "接続中",
  "home.decisionPulse.connection.connected": "リアルタイム",
  "home.decisionPulse.connection.disconnected": "切断",
  "home.decisionPulse.connection.error": "遅延あり",
  "home.calendar.eyebrow": "カレンダー",
  "home.calendar.title": "決定カレンダー",
  "home.calendar.description": "既存の詳細パネルを維持したまま、期限日ごとに決定を確認できます。",
  "home.calendar.empty": "この期間に日付付きの決定はありません。",
  "home.calendar.emptyMonth": "日付付きの決定なし",
  "home.calendar.undated": "日付なしの決定",
  "home.calendar.today": "今日",
  "home.calendar.previous": "前へ",
  "home.calendar.next": "次へ",
  "home.calendar.moreEntries": "件追加",
  "home.calendar.emptyDay": "この日に追跡中のイベントはありません。",
  "home.calendar.granularity.week": "週",
  "home.calendar.granularity.month": "月",
  "home.calendar.granularity.year": "年",
  "home.knowledgeExpirations.title": "今後の書類の期限",
  "home.knowledgeExpirations.viewAll": "すべて表示",
  "home.knowledgeExpirations.empty": "書類に近づいている期限はありません。",
  "home.knowledgeExpirations.errorTitle": "期限を読み込めませんでした",
  "home.knowledgeExpirations.errorMessage": "数秒後にもう一度お試しください。",
  "home.knowledgeEntities.title": "最近アクティビティのあるエンティティ",
  "home.knowledgeEntities.viewAll": "探索",
  "home.knowledgeEntities.sources": "件の出典",
  "home.knowledgeEntities.empty": "最近アクティビティのあるエンティティはまだありません。",
  "home.knowledgeEntities.errorTitle": "エンティティを読み込めませんでした",
  "home.knowledgeEntities.errorMessage": "数秒後にもう一度お試しください。",
  "home.calendar.agenda.empty": "今月に予定された決定はありません。",
  "home.calendar.agenda.today": "今日",
  "home.calendar.agenda.todayBadge": "今日",
  "home.calendar.agenda.previousMonth": "前の月",
  "home.calendar.agenda.nextMonth": "次の月",
  "home.viewMode.label": "表示モード",
};
